.pageContainer {
	@apply
	yst-text-center;

	margin-top: 10vh;

	h1 {
		@apply
		yst-font-bold
		yst-text-3xl;
	}

	p {
		@apply
		yst-mt-4
		yst-text-base;
	}
}
